import { FEATURE_BLOCKS } from '@/config/features';
import { CategoryMenu } from '@/components/common/CategoryMenu';

const HR_IDS = ['attendance', 'leave', 'overtime', 'approval'];
const items = FEATURE_BLOCKS.filter((b) => HR_IDS.includes(b.id));

export function HrCategoryPage() {
  return <CategoryMenu title="人事管理" description="人事相關功能" items={items} />;
}
